export const YES = {
	value: "YES",
	key:
	  "clients.client.categorisation.categoryForm.form.retirementPlanTypes.yes",
  };
  
  export const NO = {
	value: "NO",
	key:
	  "clients.client.categorisation.categoryForm.form.retirementPlanTypes.no",
  };
  
  export const PROSPECT = {
	value: "PROSPECT",
	key:
	  "clients.client.categorisation.categoryForm.form.retirementPlanTypes.prospect",
  };
  
  export default [YES, NO, PROSPECT];
  


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationRetirementPlanTypes.js